import { useEffect } from "react";

const SITE = "Arsenal Artists";
const ORIGIN = "https://arsenalartists.co";

function setTag(kind, key, value) {
  if (!value) return;
  let el = document.head.querySelector(`meta[${kind}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(kind, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
}

export default function Seo({ title, description, path = "", image = "/og-image.png" }) {
  useEffect(() => {
    const fullTitle = title ? `${title} — ${SITE}` : `${SITE} — Graphic Design, Branding & Video Editing Studio`;
    const url = `${ORIGIN}${path}`;
    const imageUrl = image.startsWith("http") ? image : `${ORIGIN}${image}`;

    document.title = fullTitle;
    setTag("name", "description", description);
    setTag("property", "og:title", fullTitle);
    setTag("property", "og:description", description);
    setTag("property", "og:url", url);
    setTag("property", "og:image", imageUrl);
    setTag("name", "twitter:title", fullTitle);
    setTag("name", "twitter:description", description);
    setTag("name", "twitter:image", imageUrl);

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);
  }, [title, description, path, image]);

  return null;
}
